import React from "react";
import TicketRouteType from "@MyTicket/types/TicketRoute.type";
import TicketNotifications from "@MyTicket/features/ticketDetails/components/TicketNotifications";
import TicketIntermodalTravelDetails from "@MyTicket/features/ticketDetails/components/TicketIntermodalTravelDetails";
import {RouteTransferTypeKeys} from "@Route/features/transportType/types/routeTransferType.type";

interface TicketIntermodalDataProps {
    ticketId: string,
    currentRoute: TicketRouteType,
    nextRoute: TicketRouteType,
    hasTransit: boolean,
    status: {
        isCancelled: boolean,
        isExchangedForVoucher : boolean,
        isExpired: boolean,
        isMTicket: boolean,
    }
    routeType: RouteTransferTypeKeys,
}

function TicketIntermodalData(props: TicketIntermodalDataProps) {
    const {
        ticketId,
        currentRoute,
        nextRoute,
        hasTransit,
        status,
        routeType,
    } = props

    return (
        <>
            <TicketNotifications
                status={status}
                routeType={routeType}
            />
            <TicketIntermodalTravelDetails
                id={ticketId}
                currentRoute={currentRoute}
                hasTransit={hasTransit}
                nextRoute={hasTransit && nextRoute}
            />
        </>
    );
}

export default TicketIntermodalData;